import { TextField } from '@mui/material';

/**
 * Input component with label and various states
 * Based on Figma design system, wraps MUI TextField for consistency
 * 
 * Uses theme-based styling from muiThemeV2 configuration
 * All visual design (colors, spacing, typography) is controlled via the theme
 * 
 * @param {object} props
 * @param {string} props.label - Input label (optional)
 * @param {string} props.placeholder - Input placeholder
 * @param {string} props.type - Input type (text, email, password, etc.)
 * @param {string} props.value - Input value
 * @param {function} props.onChange - Change handler
 * @param {boolean} props.required - Required field
 * @param {boolean} props.disabled - Disabled state
 * @param {boolean} props.error - Error state
 * @param {string} props.helperText - Helper or error text below input
 * @param {boolean} props.fullWidth - Full width input
 * @param {object} props.sx - Additional MUI sx styles
 */
export default function Input
({
    label,
    placeholder,
    type = 'text',
    value,
    onChange,
    required = false,
    disabled = false,
    error = false,
    helperText,
    fullWidth = true,
    sx = {},
    ...props
})
{
    return (
        <TextField
            type={type}
            label={label}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            error={error}
            helperText={helperText}
            fullWidth={fullWidth}
            variant="outlined"
            sx={sx}
            {...props}
        />
    );
}
